module.exports = __webpack_public_path__ + "img/logo.95110dc6.png";